import {
    RETRIEVE_ESTIMATE_EFFORT_REVIEWERS,
    CREATE_ESTIMATE_EFFORT_REVIEWER,
    UPDATE_ESTIMATE_EFFORT_REVIEWER,
    DELETE_ESTIMATE_EFFORT_REVIEWER,
} from '../../actions/types';

const initialState = {
    items: [],
    totalItems: 0,
    totalPages: 1,
    currentPage: 1,
};

function estimateEffortReviewerReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case RETRIEVE_ESTIMATE_EFFORT_REVIEWERS:
            return {
                ...state,
                items: payload.data,
                totalItems: payload.totalItems,
                totalPages: payload.totalPages,
                currentPage: payload.currentPage,
            };

        case CREATE_ESTIMATE_EFFORT_REVIEWER:
            return {
                ...state,
                items: [payload, ...state.items],
                totalItems: state.totalItems + 1,
            };

        case UPDATE_ESTIMATE_EFFORT_REVIEWER:
            return {
                ...state,
                items: state.items.map((item) => (item.id === payload.id ? payload : item)),
            };

        case DELETE_ESTIMATE_EFFORT_REVIEWER:
            return {
                ...state,
                items: state.items.filter(({ id }) => id !== payload.id),
                totalItems: state.totalItems - 1,
            };

        default:
            return state;
    }
}

export default estimateEffortReviewerReducer;
